export const theme = {
  token: {
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    colorInfo: '#1890ff',
    borderRadius: 6,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    controlHeight: 64,
  },
};

export const colors = {
  primary: '#1890ff',
  success: '#52c41a',
  warning: '#faad14',
  danger: '#f5222d',
  info: '#1890ff',
  
  bgPrimary: '#ffffff',
  bgSecondary: '#f5f7fa',
  bgLayout: '#f0f2f5',
  
  textPrimary: '#303133',
  textSecondary: '#606266',
  textMuted: '#909399',
  
  border: '#dcdfe6',
  borderLight: '#e4e7ed',
};

export default theme;
